var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upsell-settings-summary" },
    [
      _vm.getIsPricingVersion3
        ? _c("ChargebeeUpsellSettingsSummaryItemsV3")
        : [
            _c(
              "div",
              { staticClass: "upsell-settings-summary-licenses" },
              [
                _c(
                  "h2",
                  {
                    staticClass:
                      "upsell-settings-summary-heading typographies-paragraph-large-semibold"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Licences")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("ChargebeeUpsellSummaryItems", {
                  attrs: { data: _vm.subscriptionDataLicenses }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "upsell-settings-summary-options" },
              [
                _c(
                  "h2",
                  {
                    staticClass:
                      "upsell-settings-summary-heading typographies-paragraph-large-semibold"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Options")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("ChargebeeUpsellSummaryItems", {
                  attrs: { data: _vm.subscriptionDataOptions }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("div", { staticClass: "upsell-settings-summary-incoming" }, [
        _c(
          "h2",
          {
            staticClass:
              "upsell-settings-summary-heading typographies-paragraph-large-semibold"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Nouvel abonnement")))]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "typographies-paragraph-large-bold" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$filters.numberFormatCurrency(
                        _vm.humanizeCentsPrice(
                          _vm.getSubscriptionIncoming.heading.price
                        )
                      )
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                    /" +
                      _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                      "\n                "
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "upsell-settings-summary-listing" },
          _vm._l(_vm.getSubscriptionIncoming.items, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass:
                  "upsell-settings-summary-listing__item typographies-paragraph-medium-regular"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "upsell-settings-summary-listing__item-label"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.label) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "upsell-settings-summary-listing__item-price"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$filters.numberFormatCurrency(
                                _vm.humanizeCentsPrice(item.price)
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                        /" +
                            _vm._s(_vm.recurrencyLabel(item.recurrence)) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "upsell-settings-summary-current" }, [
        _c(
          "h2",
          {
            staticClass:
              "upsell-settings-summary-heading typographies-paragraph-large-semibold"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Abonnement en cours")))]),
            _vm._v(" "),
            _c("div", [
              _c("span", { staticClass: "typographies-paragraph-large-bold" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$filters.numberFormatCurrency(
                        _vm.humanizeCentsPrice(
                          _vm.subscriptionCurrent.heading.price
                        )
                      )
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _vm.subscriptionCurrent.heading.recurrence
                ? _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-semibold" },
                    [
                      _vm._v(
                        "\n                    /" +
                          _vm._s(
                            _vm.recurrencyLabel(
                              _vm.subscriptionCurrent.heading.recurrence
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "upsell-settings-summary-listing" },
          _vm._l(_vm.subscriptionCurrent.items, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass:
                  "upsell-settings-summary-listing__item typographies-paragraph-medium-regular"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "upsell-settings-summary-listing__item-label"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.label) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "upsell-settings-summary-listing__item-price"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$filters.numberFormatCurrency(
                                _vm.humanizeCentsPrice(item.price)
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                        /" +
                            _vm._s(_vm.recurrencyLabel(item.recurrence)) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }